/*eslint no-script-url: 0 */
import React, { Component } from "react";
import { Modal } from 'react-bootstrap';
import ImageFile from './ImageFile';

class UploadImage extends Component {

	constructor(props) {
		super(props);
		this.state = {
			lgShow: false,
			isUploading: false
		}
	}

	lgClose = () => {
		this.setState({ lgShow: false });
	}

	lgShow = () => {
		this.props.toggleSteps();
		this.setState({ lgShow: true, isUploading: true })
	}

	isUploadingFalse = () => {
		this.setState({ isUploading: false })
	}

	render() {
		return (
			<li className="m-b-5">
				<a href="#!" onClick={this.lgShow} className="btn btn-primary default-btn">Upload Image</a>
				{this.state.isUploading ?
					<Modal
						show={this.state.lgShow}
						onHide={this.lgClose}
						bsSize="large"
						aria-labelledby="contained-modal-title-lg"
					>
						<Modal.Header closeButton>
							<Modal.Title id="contained-modal-title-lg">Upload an Image</Modal.Title>
						</Modal.Header>
						<Modal.Body>
							<ImageFile
								{...this.props}
								lgClose={this.lgClose}
								isUploadingFalse={this.isUploadingFalse} />
						</Modal.Body>
					</Modal>
					: ''}
			</li>
		);
	}
}
export default UploadImage;